import React from 'react';
import { useTranslation } from 'react-i18next';

const Epmvmcp = () => {
  const { t } = useTranslation('help');

  return (
    <div style={styles.container}>
      {/* Title */}
      <h2 style={styles.title}>{t('epmvmcp.title', 'Moderately Vulnerable MCP')}</h2>

      {/* Section (a) - Purpose */}
      <div style={styles.section}>
        <span style={styles.sectionLabel}>(a)</span>
        <div style={styles.sectionContent}>
          <p style={styles.paragraph}>
            <strong style={styles.strongText}>
              {t('epmvmcp.labels.purpose', 'Purpose:-')}{' '}
            </strong>
            {t(
              'epmvmcp.descriptions.purpose',
              'Model Context Protocol (MCP) endpoints act as Model Context Protocol (MCP) endpoints act as standardized server URLs that allow AI prompts and models to dynamically discover and call external tools, data sources, and workflows.'
            )}
          </p>
        </div>
      </div>

      {/* Section (b) - Endpoint */}
      <div style={styles.section}>
        <span style={styles.sectionLabel}>(b)</span>
        <div style={styles.sectionContent}>
          <p style={styles.paragraph}>
            <strong style={styles.strongText}>
              {t('epmvmcp.labels.endpoint', 'Target :-')}{' '}
            </strong>
            <a 
              href="http://172.31.30.217:8005/chat" 
              style={styles.link} 
              target="_blank" 
              rel="noopener noreferrer"
            >
              http://172.31.30.217:8005/chat
            </a>
          </p>
        </div>
      </div>

      {/* Section (c) - Request Json */}
      <div style={styles.section}>
        <span style={styles.sectionLabel}>(c)</span>
        <div style={styles.sectionContent}>
          <p style={styles.paragraph}>
            <strong style={styles.strongText}>
              {t('epmvmcp.labels.requestJson', 'Request Json')}
            </strong>
          </p>
          <p style={styles.paragraph}>
            {t(
              'epmvmcp.descriptions.requestJson',
              'The simulator accepts an application/json body. AUTH_KEY is required inside request_template and must match an authorized key. The endpoint validates it on every request and returns HTTP 401 when it is missing or invalid.'
            )}
          </p>

          {/* Request JSON Code Block */}
          <div style={styles.codeBlock}>
            <div>{'{'}</div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"headers"</span>: {'{'}
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonKey}>"Content-Type"</span>: <span style={styles.jsonString}>"application/json"</span>
            </div>
            <div style={styles.indent1}>{'}'},</div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"data_type"</span>: <span style={styles.jsonString}>"json"</span>,
            </div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"request_template"</span>: {'{'}
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonKey}>"AUTH_KEY"</span>: <span style={styles.jsonString}>"&lt;authorized-key&gt;"</span>,
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonKey}>"message"</span>: <span style={styles.jsonString}>"{"{{PROMPT}}"}"</span>
            </div>
            <div style={styles.indent1}>{'}'},</div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"prompt_path"</span>: <span style={styles.jsonString}>"message"</span>
            </div>
            <div>{'}'}</div>
          </div>
        </div>
      </div>

      {/* Section (d) - Response json */}
      <div style={styles.section}>
        <span style={styles.sectionLabel}>(d)</span>
        <div style={styles.sectionContent}>
          <p style={styles.paragraph}>
            <strong style={styles.strongText}>
              {t('epmvmcp.labels.responseJson', 'Response json')}
            </strong>
          </p>
          <p style={styles.paragraph}>
            {t(
              'epmvmcp.descriptions.responseJson',
              'The message field contains the simulator output. Moderate mode may return an allowed HTTP 200 response, a refused HTTP 403 response, or an HTTP 429 infrastructure response.'
            )}
          </p>

          {/* Response JSON Code Block */}
          <div style={styles.codeBlock}>
            <div>{'{'}</div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"status"</span>: <span style={styles.jsonString}>"refused"</span>,
            </div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"blocked"</span>: <span style={styles.jsonBoolean}>true</span>,
            </div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"mode"</span>: <span style={styles.jsonString}>"moderate"</span>,
            </div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"message"</span>: <span style={styles.jsonString}>"{"{{RESP}}"}"</span>
            </div>
            <div>{'}'}</div>
          </div>

          {/* Expected Test Results */}
          <p style={styles.paragraph}>
            <strong style={styles.strongText}>
              {t(
                'epmvmcp.labels.expectedResults',
                '(e) Expected Test Results against this simulator:-'
              )}{' '}
            </strong>
            {t(
              'epmvmcp.descriptions.expectedResults',
              'For a moderately vulnerable MCP simulator, the expected readiness result scores should be less than 30% across the applicable categories.'
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

// Component Styles (Dark Theme)
const styles = {
  container: {
    maxWidth: '850px',
    margin: '0 auto',
    padding: '24px',
    color: '#e0e0e0',
    backgroundColor: '#181a1f',
    borderRadius: '8px',
    fontFamily: 'Segoe UI, Roboto, sans-serif'
  },
  title: {
    margin: '0 0 20px 0',
    fontWeight: 'bold',
    color: '#ffffff',
    fontSize: '20px'
  },
  section: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '15px'
  },
  sectionLabel: {
    width: '32px',
    flexShrink: 0,
    fontWeight: 'bold',
    color: '#a0a0a0'
  },
  sectionContent: {
    flexGrow: 1
  },
  paragraph: {
    margin: '0 0 10px 0',
    lineHeight: '1.6',
    color: '#cccccc',
    fontSize: '14px'
  },
  strongText: {
    color: '#ffffff'
  },
  link: {
    color: '#4fa3d1',
    textDecoration: 'underline'
  },
  codeBlock: {
    backgroundColor: '#0d0e11',
    color: '#e0e0e0',
    padding: '16px 20px',
    margin: '12px 0',
    borderRadius: '6px',
    border: '1px solid #2a2d34',
    fontFamily: 'Consolas, Monaco, "Andale Mono", monospace',
    fontSize: '13px',
    lineHeight: '1.5',
    overflowX: 'auto',
    whiteSpace: 'pre'
  },
  indent1: {
    paddingLeft: '20px'
  },
  indent2: {
    paddingLeft: '40px'
  },
  jsonKey: {
    color: '#6fc2ef'
  },
  jsonString: {
    color: '#e59373'
  },
  jsonBoolean: {
    color: '#569cd6'
  }
};

export default Epmvmcp;